import React from 'react'
import { Download } from 'lucide-react'
import { usePwaInstall } from './common/Common'

const Footer = () => {
    const { canInstall, install } = usePwaInstall()

    return (
        <footer className="site-footer">
            <div className="site-footer-brand">Recify<span>.</span></div>
            <div>
                &copy; {new Date().getFullYear()}{" "}
                <a href="/">Joshan Sapkota</a>
            </div>
            {canInstall && (
                <button className="install-btn" onClick={install}>
                    <Download size={15} /> Install Recify
                </button>
            )}
        </footer>
    );
}

export default Footer
